export default __webpack_public_path__ + "static/media/header_light.92ed5934.png";